import React, { useEffect, useState, useRef } from 'react';
import { XIcon } from 'lucide-react';
const galleryImages = [{
  id: 1,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bEuKQaUikKg8C9R25fLZ8a/Screenshot_2025-09-08_at_11.19.51_PM.png',
  alt: 'Trung Nguyen with government official',
  altVi: 'Trung Nguyen với quan chức chính phủ',
  caption: 'Meeting with government officials to discuss immigration policy',
  captionVi: 'Gặp gỡ với các quan chức chính phủ để thảo luận về chính sách nhập cư',
  category: 'Leadership'
}, {
  id: 2,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tzEjKnU9beWeD8xaNdeagZ/AidWorks_Team.jpg',
  alt: 'AidWorks birthday celebration',
  altVi: 'Lễ kỷ niệm sinh nhật AidWorks',
  caption: 'AidWorks Foundation team celebrating my birthday',
  captionVi: 'Đội ngũ AidWorks Foundation tổ chức sinh nhật của tôi',
  category: 'AidWorks'
}, {
  id: 3,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uwdp1VMh5rPa1FUQuhM6Nz/DECA_Win.jpg',
  alt: 'DECA finalist picture',
  altVi: 'Hình ảnh chung kết DECA',
  caption: 'DECA International Finalist with my team',
  captionVi: 'Chung kết DECA Quốc tế cùng đội của tôi',
  category: 'Education'
}, {
  id: 4,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rv7J1FxSZz93vr9UqkUG8z/F1RST_Scholar.jpg',
  alt: 'F1RST Scholar',
  altVi: 'Học giả F1RST',
  caption: 'F1RST Scholars Program at Northeastern University',
  captionVi: 'Chương trình F1RST Scholars tại Đại học Northeastern',
  category: 'Education'
}, {
  id: 5,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kDduE12GVnBjGwNnLYBxsW/HCM_Intern_Mixer.jpg',
  alt: 'HCM Intern Mixer',
  altVi: 'Sự kiện giao lưu thực tập sinh HCM',
  caption: 'Ho Chi Minh City Finance Intern Mixer',
  captionVi: 'Sự kiện giao lưu Thực tập sinh Tài chính tại Thành phố Hồ Chí Minh',
  category: 'Professional'
}, {
  id: 6,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1pA8HFCnw1ffULCKY7Kccn/OCB_Team.jpg',
  alt: 'OCB Team',
  altVi: 'Đội OCB',
  caption: 'With the OCB FX Sales & Trading team in Ho Chi Minh City',
  captionVi: 'Cùng đội ngũ OCB FX Sales & Trading tại Thành phố Hồ Chí Minh',
  category: 'Professional'
}, {
  id: 7,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kry5e1AVVsViq1mL632Tfa/VNPress.png',
  alt: 'Vietnam Press Interview',
  altVi: 'Phỏng vấn Báo chí Việt Nam',
  caption: 'Being interviewed by Vietnamese press about scholarship initiatives',
  captionVi: 'Được phỏng vấn bởi báo chí Việt Nam về các sáng kiến học bổng',
  category: 'Leadership'
}, {
  id: 8,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3M2YsaBEgh5WbUNXg6Ssnk/With_Vice_President.jpg',
  alt: 'Meeting with Official',
  altVi: 'Gặp gỡ với Quan chức',
  caption: 'Formal meeting with government officials to discuss youth initiatives',
  captionVi: 'Cuộc họp chính thức với các quan chức chính phủ để thảo luận về các sáng kiến thanh niên',
  category: 'Leadership'
}, {
  id: 9,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1ASpzWLVqBaWXAj9BNmdcA/Dalat_2025.jpg',
  alt: 'Dalat Waterfall Trip',
  altVi: 'Chuyến đi thác Đà Lạt',
  caption: "Exploring Dalat's beautiful waterfalls with friends in 2025",
  captionVi: 'Khám phá những thác nước tuyệt đẹp ở Đà Lạt cùng bạn bè vào năm 2025',
  category: 'Travel'
}, {
  id: 10,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/goqzdGJ7hhwWyMSW8qpa5T/DECA.jpg',
  alt: 'DECA Conference',
  altVi: 'Hội nghị DECA',
  caption: 'DECA team at the business conference in formal attire',
  captionVi: 'Đội DECA tại hội nghị kinh doanh trong trang phục chính thức',
  category: 'Education'
}, {
  id: 11,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ixshGejZuRDbSPCBUbN2N9/Stephen_Kaufer_TripAdvisor_CEO_2.png',
  alt: 'Meeting with TripAdvisor CEO',
  altVi: 'Gặp gỡ với CEO TripAdvisor',
  caption: 'Networking with Stephen Kaufer, CEO of TripAdvisor',
  captionVi: 'Kết nối với Stephen Kaufer, Giám đốc điều hành của TripAdvisor',
  category: 'Professional'
}, {
  id: 12,
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bute2X5CgBiAR4kNvkbZwa/student_government.jpg',
  alt: 'Student Government Team',
  altVi: 'Đội Chính phủ Sinh viên',
  caption: 'Leading the student government team during a school event',
  captionVi: 'Lãnh đạo đội ngũ chính phủ sinh viên trong một sự kiện trường học',
  category: 'Leadership'
}];
const PhotoGallery = ({
  language = 'en'
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState('All');
  const [filteredImages, setFilteredImages] = useState(galleryImages);
  const lightboxRef = useRef(null);
  const sectionRef = useRef(null);
  // Translations for categories
  const categoryTranslations = {
    en: {
      All: 'All',
      Leadership: 'Leadership',
      AidWorks: 'AidWorks',
      Education: 'Education',
      Professional: 'Professional',
      Travel: 'Travel'
    },
    vi: {
      All: 'Tất cả',
      Leadership: 'Lãnh đạo',
      AidWorks: 'AidWorks',
      Education: 'Học vấn',
      Professional: 'Chuyên môn',
      Travel: 'Du lịch'
    }
  };
  const translations = {
    en: {
      photo: 'Photo',
      gallery: 'Gallery',
      fullArticle: 'Full Article',
      close: 'Close'
    },
    vi: {
      photo: 'Thư Viện',
      gallery: 'Hình Ảnh',
      fullArticle: 'Bài Viết Đầy Đủ',
      close: 'Đóng'
    }
  };
  const t = translations[language];
  const categories = ['All', ...new Set(galleryImages.map(img => img.category))];
  useEffect(() => {
    if (activeFilter === 'All') {
      setFilteredImages(galleryImages);
    } else {
      setFilteredImages(galleryImages.filter(img => img.category === activeFilter));
    }
  }, [activeFilter]);
  useEffect(() => {
    const handleClickOutside = event => {
      if (lightboxRef.current && !lightboxRef.current.contains(event.target)) {
        setSelectedImage(null);
      }
    };
    if (selectedImage) {
      document.addEventListener('mousedown', handleClickOutside);
      // Prevent scrolling when lightbox is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [selectedImage]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.fade-in, .scale-in');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const openLightbox = image => {
    setSelectedImage(image);
  };
  const closeLightbox = () => {
    setSelectedImage(null);
  };
  return <section id="gallery" ref={sectionRef} className="w-full py-24 bg-secondary" data-id="element-386">
      <div className="container mx-auto px-4" data-id="element-387">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-16 fade-in" data-id="element-388">
          {t.photo} <span className="gradient-text" data-id="element-389">{t.gallery}</span>
        </h2>
        {/* Category Filter - Scrollable on mobile */}
        <div className="mb-12 fade-in overflow-x-auto pb-2" data-id="element-390">
          <div className="flex flex-nowrap justify-start md:justify-center gap-3 min-w-max md:min-w-0 px-1" data-id="element-391">
            {categories.map((category, index) => <button key={index} onClick={() => setActiveFilter(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${activeFilter === category ? 'bg-gradient-to-r from-accent-cyan to-accent-violet text-white shadow-lg transform scale-105' : 'bg-background text-muted hover:text-primary hover:bg-background/80'}`} data-id="element-392">
                {categoryTranslations[language][category] || category}
              </button>)}
          </div>
        </div>
        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-393">
          {filteredImages.map((image, index) => <div key={image.id} className="scale-in overflow-hidden rounded-xl bg-background card-glow cursor-pointer transform transition-all duration-500 hover:scale-105" style={{
          animationDelay: `${index * 100}ms`
        }} onClick={() => openLightbox(image)} data-id="element-394">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-395">
                <img src={image.src} alt={language === 'en' ? image.alt : image.altVi} className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" data-id="element-396" />
              </div>
              <div className="p-4" data-id="element-397">
                <div className="inline-block px-3 py-1 mb-2 text-xs font-medium bg-accent-cyan/20 text-accent-cyan rounded-full" data-id="element-398">
                  {categoryTranslations[language][image.category] || image.category}
                </div>
                <p className="text-primary font-medium" data-id="element-399">
                  {language === 'en' ? image.caption : image.captionVi}
                </p>
              </div>
            </div>)}
        </div>
      </div>
      {/* Lightbox - Optimized for mobile */}
      {selectedImage && <div className="fixed inset-0 bg-background/95 z-50 flex items-center justify-center p-2 sm:p-4" data-id="element-400">
          <div ref={lightboxRef} className="relative max-w-5xl w-full bg-secondary rounded-2xl overflow-hidden card-glow flex flex-col md:flex-row max-h-[90vh]" data-id="element-401">
            <button onClick={closeLightbox} className="absolute top-4 right-4 z-10 bg-background/50 rounded-full p-2 text-primary hover:text-accent-cyan transition-colors" aria-label={t.close} data-id="element-402">
              <XIcon size={24} data-id="element-403" />
            </button>
            <div className="w-full md:w-3/4 bg-background flex items-center justify-center" data-id="element-404">
              <img src={selectedImage.src} alt={language === 'en' ? selectedImage.alt : selectedImage.altVi} className="w-full h-auto object-contain max-h-[50vh] md:max-h-[80vh]" data-id="element-405" />
            </div>
            <div className="w-full md:w-1/4 p-6 flex flex-col justify-between overflow-y-auto" data-id="element-406">
              <div data-id="element-407">
                <div className="inline-block px-3 py-1 mb-3 text-sm font-medium bg-accent-cyan/20 text-accent-cyan rounded-full" data-id="element-408">
                  {categoryTranslations[language][selectedImage.category] || selectedImage.category}
                </div>
                <h3 className="text-xl font-display font-bold mb-3" data-id="element-409">
                  {language === 'en' ? selectedImage.alt : selectedImage.altVi}
                </h3>
                <p className="text-muted" data-id="element-410">
                  {language === 'en' ? selectedImage.caption : selectedImage.captionVi}
                </p>
              </div>
            </div>
          </div>
        </div>}
    </section>;
};
export default PhotoGallery;